<template>
  <div style="display: flex;">
    <div class="shipping-table-container" style="width: 50%;">
      <el-card class="table-card" shadow="hover">
        <div slot="header" class="card-header">
          <span>库存预警列表</span>

          <el-select v-model="goodsType" filterable placeholder="请选择" @change="fetchData">
            <el-option label="本月" :value="1" />
            <el-option label="本周" :value="2" />
          </el-select>


        </div>
        <el-table :data="stockWarning" stripe style="width: 100%" size="medium">
          <!-- 商品名称 -->
          <el-table-column prop="name" label="商品名称"></el-table-column>
          <!-- 商品编号 -->
          <!-- <el-table-column prop="itemNo" label="商品编号"></el-table-column> -->
          <!-- 库位类型 -->
          <!-- <el-table-column align="center" label="库位类型" width="90">
      <template slot-scope="scope">
        {{ scope.row.shelfTypeFlag == 1 ? '轻型' : '重型' }}
      </template>
</el-table-column> -->
          <!-- 当前库存 -->
          <!-- <el-table-column prop="quantity" label="当前库存" width="100"></el-table-column> -->
          <!-- 安全阈值 -->
          <el-table-column prop="removal_time" label="下架时间" width="200"></el-table-column>
          <el-table-column label="状态" width="80">
            <template slot-scope="scope">
              <el-tag type="danger" size="mini" class="blink-tag">紧急</el-tag>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>
    <div class="shipping-table-container">
      <div class="table-header">
        <div class="title-section">
          <!-- <el-input
          v-model="user_code"
          placeholder="请输入用户编号"
          clearable
          @keyup.enter.native="queryData"
        /> -->
          <el-select v-model="kor_type" filterable placeholder="请选择" @change="queryData">
            <el-option label="韩到中线路" :value="0" />
            <el-option label="韩到日线路" :value="3" />
            <el-option label="韩到马来线路" :value="4" />
            <el-option label="中到马来线路" :value="5" />
          </el-select>
          <el-date-picker v-model="selectedMonth" type="month" placeholder="选择年月" format="yyyy年MM月"
            value-format="yyyy-MM" :clearable="false" :editable="false" @change="handleMonthChange"></el-date-picker>
        </div>
        <button class="export-btn" @click="exportData">
          <i class="export-icon"></i>
          导出本月数据
        </button>
      </div>

      <!-- 表格容器：固定高度，滚动条 -->
      <div class="table-wrapper">
        <table class="data-table">
          <thead>
            <tr>
              <th>用户</th>
              <th>总下单数</th>
              <th>本月下单数</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in userList" :key="index">
              <td class="user-cell">
                {{ item?.user?.nickname || '-' }} {{ item?.user?.ydm_code }}
                {{ item?.user?.code }}
              </td>
              <td>{{ item.num || item.totalOrders || 0 }}</td>
              <td class="month-orders">
                {{ item.month_num || item.monthOrders || 0 }}
              </td>
            </tr>
            <!-- 空数据提示 -->
            <tr v-if="userList.length === 0">
              <td colspan="3" class="empty-cell">暂无数据</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="table-footer">
        <span class="note-text">
          *注：首页仅展示前20位用户数据，请导出查看全部用户数据
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { OrderStatistics, month_order_user_excel, GoodsWarning } from '@/api/xgcApi'
import { getUploadUrl } from '@/config'
export default {
  name: 'ShippingDataTable',

  data() {
    return {
      goodsType: 1,
      user_code: '',
      kor_type: 4,
      selectedMonth: '',
      startTime: '',
      endTime: '',
      userList: [],
      allUsers: [],
      stockWarning: []
    }
  },

  mounted() {
    // 获取当前年月
    const now = new Date()
    const currentYear = now.getFullYear()
    const currentMonth = now.getMonth() + 1
    const defaultMonth = `${currentYear}-${String(currentMonth).padStart(
      2,
      '0'
    )}`
    this.selectedMonth = defaultMonth

    // 初始化计算当前月份的时间范围
    this.calculateMonthRange(this.selectedMonth)
    // 初始化加载数据
    this.queryData()
    this.fetchData()
    console.log(this.selectedMonth, 'selectedMonth')
  },

  methods: {
    async exportData() {
      console.log('导出本月数据', {
        startTime: this.startTime,
        endTime: this.endTime,
        kor_type: this.kor_type,
      })

      const date = {
        start_time: this.startTime,
        end_time: this.endTime,
        kor_type: this.kor_type,
      }

      const { data } = await month_order_user_excel(date)
      const fileUrl = getUploadUrl + data
      window.open(fileUrl)
      this.$message({
        type: 'success',
        message: '导出成功',
      })
    },

    formatDateTime(date) {
      const y = date.getFullYear()
      const m = String(date.getMonth() + 1).padStart(2, '0')
      const d = String(date.getDate()).padStart(2, '0')
      const h = String(date.getHours()).padStart(2, '0')
      const min = String(date.getMinutes()).padStart(2, '0')
      const s = String(date.getSeconds()).padStart(2, '0')
      return `${y}-${m}-${d} ${h}:${min}:${s}`
    },

    calculateMonthRange(yearMonth) {
      if (!yearMonth) return null

      const [year, month] = yearMonth.split('-').map(Number)

      const startDate = new Date(year, month - 1, 1, 0, 0, 0)
      const endDate = new Date(year, month, 1, 0, 0, 0)

      this.startTime = this.formatDateTime(startDate)
      this.endTime = this.formatDateTime(endDate)

      console.log('时间范围:', this.startTime, '至', this.endTime)

      return {
        startTime: this.startTime,
        endTime: this.endTime,
      }
    },

    handleLineChange(value) {
      console.log('切换线路:', value)
      this.queryData()
    },

    handleMonthChange(value) {
      if (value) {
        this.selectedMonth = value
        this.calculateMonthRange(value)
        this.queryData()
      }
    },

    queryData() {
      const data = {
        user_code: this.user_code,
        start_time: this.startTime,
        end_time: this.endTime,
        kor_type: this.kor_type,
      }

      OrderStatistics(data)
        .then((res) => {
          console.log(res, 'res')
          this.userList = res.data || []
        })
        .catch((err) => {
          console.error('查询失败:', err)
          this.$message.error('数据加载失败')
          this.userList = []
        })
    },
    async fetchData() {
      const { data } = await GoodsWarning({})
      if (this.goodsType == 1) {
        this.stockWarning = data.goods_month
      } else {
        this.stockWarning = data.goods_week
      }
    }
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-input__inner {
  background: #f7f8fc;
  border: none;
  color: #5470c6;
  font-size: 18px;
  width: 240px;
}

//  max-width: 1200px;
.shipping-table-container {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, sans-serif;
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08), 0 4px 12px rgba(0, 0, 0, 0.04);
  padding: 24px 28px;
  width: 40%;

  min-height: 60vh !important;
  margin: 0 auto;
  transition: all 0.3s ease;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;
}

.title-section {
  display: flex;
  align-items: baseline;
  gap: 16px;
  // flex-wrap: wrap;
}

/* 表格包装器 - 固定高度，滚动条 */
.table-wrapper {
  overflow-x: auto;
  overflow-y: auto;
  max-height: 500px;
  /* 固定最大高度，超出显示滚动条 */
  border-radius: 12px;
  border: 1px solid #eef2f6;
  background-color: #fff;
  margin-bottom: 20px;
  position: relative;
}

/* 表格样式 - 实现表头固定 */
.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  min-width: 560px;
}

/* 表头固定关键样式 */
.data-table thead tr {
  position: sticky;
  top: 0;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  z-index: 10;
}

.data-table thead tr th {
  position: sticky;
  top: 0;
  background-color: #f8fafc;
  z-index: 10;
}

.data-table th {
  text-align: left;
  padding: 16px 20px;
  font-weight: 600;
  color: #1e293b;
  font-size: 14px;
  letter-spacing: 0.3px;
  border-bottom: 1px solid #e2e8f0;
  background-color: #f8fafc;
}

.data-table td {
  padding: 14px 20px;
  border-bottom: 1px solid #f0f2f5;
  color: #334155;
  font-weight: 450;
  transition: background-color 0.2s ease;
}

.data-table tbody tr:hover {
  background-color: #fafcff;
  box-shadow: inset 0 0 0 1px #e6f0ff;
}

.data-table tbody tr:last-child td {
  border-bottom: none;
}

.user-cell {
  font-family: 'SF Mono', 'Menlo', monospace;
  font-weight: 500;
  color: #0f172a;
  letter-spacing: 0.2px;
}

/* 空数据样式 */
.empty-cell {
  text-align: center;
  padding: 40px 20px !important;
  color: #99a9bf;
}

.data-table td:nth-child(3) {
  font-weight: 600;
}

.table-footer {
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px dashed #e4e7eb;
}

.note-text {
  font-size: 12px;
  color: #8a99b4;
  background: #f9fafc;
  padding: 6px 12px;
  border-radius: 8px;
  display: inline-block;
  letter-spacing: 0.2px;
}

/* 滚动条样式美化 */
.table-wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.table-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.table-wrapper::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}

.table-wrapper::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* 导出按钮 */
.export-btn {
  /* background: linear-gradient(135deg, #1890ff 0%, #096dd9 100%);s */
  background: #5470c6;
  border: none;
  padding: 10px 24px;
  border-radius: 4px;
  color: white;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 4px rgba(24, 144, 255, 0.2);
}

.export-btn:hover {
  background: linear-gradient(135deg, #40a9ff 0%, #1890ff 100%);
  transform: translateY(-1px);
  box-shadow: 0 6px 12px rgba(24, 144, 255, 0.25);
}

.export-btn:active {
  transform: translateY(1px);
}

.export-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3E%3Cpath d='M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z'/%3E%3C/svg%3E") no-repeat center;
  background-size: contain;
  filter: brightness(0) invert(1);
}

/* 响应式调整 */
@media (max-width: 768px) {
  .shipping-table-container {
    padding: 16px 18px;
    border-radius: 12px;
  }

  .table-wrapper {
    max-height: 400px;
  }

  .data-table th,
  .data-table td {
    padding: 12px 16px;
  }
}
</style>
<style scoped>
@keyframes gentle-blink {
  0% {
    opacity: 1;
    border-color: #ff4949;
  }

  50% {
    opacity: 0.6;
    border-color: #ffa0a0;
  }

  100% {
    opacity: 1;
    border-color: #ff0000;
    box-shadow: 0 0 5px #ff0000;
  }
}

.blink-tag {
  animation: gentle-blink 1s ease-in-out infinite;
}

.zero-value {
  color: #c0c4cc;
}

.warehouse-dashboard {
  min-height: 100vh;
  background-color: #f5f7fa;
  display: flex;
  flex-direction: column;
}

/* 顶部导航 */
.dashboard-header {
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  flex-shrink: 0;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.toggle-menu {
  font-size: 20px;
  color: #5a6a7e;
  cursor: pointer;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 24px;
}

.notice-badge {
  cursor: pointer;
}

.user-dropdown {
  cursor: pointer;
  color: #2c3e50;
  font-weight: 500;
}

/* 主体 */
.dashboard-main {
  padding: 24px;
  overflow-y: auto;
}

.welcome-section {
  margin-bottom: 24px;
}

.welcome-section h2 {
  font-size: 24px;
  font-weight: 500;
  color: #1f2d3d;
}

.welcome-section p {
  color: #6b7785;
  margin-top: 4px;
}

/* 统计卡片 */
.stat-cards {
  margin-bottom: 24px;
}

.stat-card {
  display: flex;
  align-items: center;
  border: none;
  border-radius: 12px;
}

.stat-icon {
  width: 56px;
  height: 56px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
}

.stat-icon i {
  font-size: 28px;
  color: #2c6bff;
}

.stat-info {
  flex: 1;
}

.stat-label {
  font-size: 14px;
  color: #7a869a;
  margin-top: 4px;
  margin-bottom: 4px;
}

.stat-value {
  font-size: 26px;
  font-weight: 600;
  color: #1f2d3d;
  line-height: 1.2;
}

.stat-trend {
  font-size: 12px;
  margin-top: 6px;
}

.stat-trend.up {
  color: #52c41a;
}

.stat-trend.down {
  color: #f5222d;
}

/* 图表待办区域 */
.chart-todo-row {
  margin-bottom: 24px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.chart-placeholder {
  height: 240px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 16px 0;
}

.bar-chart-simulator {
  display: flex;
  width: 100%;
  justify-content: space-around;
  align-items: flex-end;
  height: 180px;
}

.bar-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 40px;
}

.bar-label {
  font-size: 12px;
  color: #8c8c8c;
  margin-bottom: 8px;
}

.bar-container {
  display: flex;
  gap: 4px;
  height: 150px;
  align-items: flex-end;
}

.bar {
  width: 16px;
  border-radius: 4px 4px 0 0;
  transition: height 0.3s;
}

.in-bar {
  background-color: #409eff;
}

.out-bar {
  background-color: #f9ae3d;
}

/* 待办卡片 */
.todo-list {
  margin-bottom: 12px;
}

.todo-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #f0f2f5;
}

.todo-item .el-checkbox {
  flex: 1;
}

.warn-items {
  margin-top: 12px;
}

.warn-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding: 8px 0;
  border-bottom: 1px dashed #eee;
}

.warn-item i {
  color: #faad14;
  margin-right: 8px;
}

.warn-num {
  color: #bfbfbf;
  font-size: 12px;
}

/* 表格区域 */
.table-row {
  margin-bottom: 20px;
}

.table-card {
  border-radius: 12px;
}

.task-footer {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #1f2d3d;
  margin-bottom: 6px;
}

/* 适配小屏幕 */
@media (max-width: 768px) {
  .stat-cards .el-col {
    margin-bottom: 16px;
  }

  .bar-item {
    width: 24px;
  }

  .bar {
    width: 10px;
  }
}
</style>